import React from 'react';
import { colors, styles } from '../theme';
import ArchetypeCard from './ArchetypeCard';

// Tier 2 entry surface. Renders a grid of curated archetype cards.
//
// P1 in action: zero `<select>` elements; every visible choice is a card with
// a portrait, a story-anchored "Plays like" subtitle, and a 2-feature
// foreshadow. The user picks by reading, not by filtering.
//
// Phase 2 ships 2 archetypes (Heavy-Armor Fighter, Healer Cleric) — the
// minimum to validate the gallery + customize flow against authored SRD
// content. Phase 3 (SRD content) unlocks 6-8 more archetypes; the gallery is
// data-driven so no UI changes needed.

const ArchetypeGallery = ({ archetypes, onInspect, onSelect, onBack }) => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <button
          type="button"
          onClick={onBack}
          data-testid="back-to-mode-select"
          style={{
            ...styles.buttonGhost,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            marginBottom: 16,
          }}
        >
          ← Change how you start
        </button>

        <header style={{ marginBottom: 32, textAlign: 'center' }}>
          <h1
            style={{
              ...styles.heading,
              fontSize: 36,
              letterSpacing: 1,
            }}
          >
            Choose an Archetype
          </h1>
          <p style={styles.subheading}>
            Each archetype is a fully-built level-1 character. You can tweak everything after
            picking.
          </p>
        </header>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 20,
            marginBottom: 32,
          }}
          data-testid="archetype-gallery-grid"
        >
          {archetypes.length > 0 ? (
            archetypes.map((archetype) => (
              <ArchetypeCard
                key={archetype.id}
                archetype={archetype}
                onInspect={onInspect}
                onSelect={onSelect}
              />
            ))
          ) : (
            <div
              data-testid="archetype-gallery-empty"
              style={{
                gridColumn: '1 / -1',
                padding: 32,
                textAlign: 'center',
                color: colors.textMuted,
                fontStyle: 'italic',
              }}
            >
              No archetypes available yet. Try &ldquo;Build from scratch&rdquo; below.
            </div>
          )}
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '16px 0',
            borderTop: `1px solid ${colors.borderLight}`,
          }}
        >
          <span style={{ color: colors.textMuted, fontSize: 13, marginRight: 12 }}>
            Don&rsquo;t see one you like?
          </span>
          <button
            type="button"
            onClick={() => onSelect?.('__from-scratch__')}
            data-testid="build-from-scratch"
            style={styles.buttonSecondary}
          >
            Build from scratch instead
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArchetypeGallery;
